import { render, staticRenderFns } from "./TaxGroupViewGlobal.vue?vue&type=template&id=21245c35&"
import script from "./TaxGroupViewGlobal.vue?vue&type=script&lang=js&"
export * from "./TaxGroupViewGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports